export const PAGINATION = {
  itemsPerPage: 10,
};
